import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumConsumableType implements BaseEnumType {
  private static allValues: EnumConsumableType[] = []; // make sure this is top-most
  
  public static caskLabel = new EnumConsumableType(0, "CaskLabel", "enum_consumable_type_cask_label");
  public static caseLabel = new EnumConsumableType(1, "CaseLabel", "enum_consumable_type_case_label");
  public static cleaningCard = new EnumConsumableType(2, "CleaningCard", "enum_consumable_type_cleaning_card");
  public static deliveryCharge = new EnumConsumableType(3, "DeliveryCharge", "enum_consumable_type_delivery_charge");
  public static printer = new EnumConsumableType(4, "Printer", "enum_consumable_type_printer");
  public static ribbon = new EnumConsumableType(5, "Ribbon", "enum_consumable_type_ribbon");
  public static scanner = new EnumConsumableType(6, "Scanner", "enum_consumable_type_scanner");
  public static permanentLabel = new EnumConsumableType(7, "PermanentLabel", "enum_consumable_type_permanent_label");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumConsumableType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isCaskLabel() { return this === EnumConsumableType.caskLabel; }
  public isCaseLabel() { return this === EnumConsumableType.caseLabel; }
  public isCleaningCard() { return this === EnumConsumableType.cleaningCard; }
  public isDeliveryCharge() { return this === EnumConsumableType.deliveryCharge; }
  public isPrinter() { return this === EnumConsumableType.printer; }
  public isRibbon() { return this === EnumConsumableType.ribbon; }
  public isScanner() { return this === EnumConsumableType.scanner; }
  public isPermanentLabel() { return this === EnumConsumableType.permanentLabel; }

  public static getValues(): readonly EnumConsumableType[] {
    return EnumConsumableType.allValues;
  }

  public static getValuesExcept0(): readonly EnumConsumableType[] {
    return EnumConsumableType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumConsumableType {
    const found = EnumConsumableType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumConsumableType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumConsumableType): EnumConsumableType {
    const found = name ? EnumConsumableType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumConsumableType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumConsumableType>): boolean {
    return this.key === other?.key;
  }
}